import {testIdProps} from '@github-ui/test-id-props'
import {PlusIcon} from '@primer/octicons-react'

import {WorkflowResources} from '../../../strings'
import {AutomationBlock} from './automation-block'

export const AddItemBlock = () => {
  return (
    <AutomationBlock
      icon={PlusIcon}
      iconBg="success.subtle"
      iconColor="success.fg"
      headerDescription={WorkflowResources.addItemBlockLabel}
      {...testIdProps('automation-add-item-block')}
    />
  )
}

try{ AddItemBlock.displayName ||= 'AddItemBlock' } catch {}